i
<template>
  <div class="pg-download-app">
    <div class="pg-download-app__item" v-for="(system, index) in appList" :key="index + '_system'">
      <p class="pg-download-app__title">{{ system.system.title }}</p>
      <p class="pg-download-app__title">{{ system.system.detail }}</p>
      <ul class="pg-download-app__cont">
        <li v-for="(terminal, index) in system.releases" :key="index + '_terminal'">
          <i :class="[terminal.icon]" style="font-size: 35px"></i>
          <p style="font-size: 14px">{{ terminal.platform }}</p>
          <img :src="handleUrl(terminal.url)" />
          <p class="pg-download-app__bottomText">扫描二维码</p>
          <p class="pg-download-app__bottomText">
            下载{{ terminal.platform == 'Android' ? '安卓' : 'iOS' }}客户端
          </p>
        </li>
      </ul>
    </div>
    <div class="pg-download-app__empty" v-if="appList.length === 0">暂未提供APP</div>
  </div>
</template>
<script setup>
import { getDomain } from '../../../utils/index'
import { getCurrentInstance } from 'vue'
defineProps({
  appList: {
    type: [Object, Array],
    default: () => [],
  },
})

const { proxy } = getCurrentInstance()
const handleUrl = (url) => {
  return url
    ? getDomain(proxy.GLOBAL.contentServerURL) +
        'rest/ezcomp/barcode/encodeURL?data=' +
        encodeURIComponent(getDomain(url))
    : null
}
</script>
<style lang="scss">
@import '../style/download-app.scss';
</style>
